import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Spin } from 'antd';

export const NotFound = () => {
  const classess = useStyles();

  return (
    <div className={classess.notFound}>
      <p style={{ fontSize: '14px' }}>There are no results</p>
    </div>
  );
};

export const DropDownItem = ({ title, onClick }) => {
  return (
    <p onClick={onClick} style={{ fontSize: '14px' }}>
      {title}
    </p>
  );
};

export const Searching = () => {
  const classess = useStyles();
  return (
    <div className={classess.searching}>
      <Spin spinning={true}>
        <div style={{ width: '396px', maxWidth: '100%' }}>
          <p>Searching...</p>
        </div>
      </Spin>
    </div>
  );
};

const useStyles = makeStyles({
  searching: {
    height: '200px',
    display: 'flex',
    justifyContent: 'center',
  },
  notFound: {
    display: 'flex',
    justifyContent: 'center',
    width: '396px',
    height: '250px',
    maxWidth: '100%',

    '& p': {
      '&:hover': {
        background: 'white',
      },
    },
  },
});
